/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxRate
 */
export interface FxRate {
    /**
     * 
     * @type {string}
     * @memberof FxRate
     */
    fromCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof FxRate
     */
    toCurrency: string;
    /**
     * 
     * @type {number}
     * @memberof FxRate
     */
    rate: number;
    /**
     * 
     * @type {Date}
     * @memberof FxRate
     */
    validFrom: Date;
}

/**
 * Check if a given object implements the FxRate interface.
 */
export function instanceOfFxRate(value: object): value is FxRate {
    if (!('fromCurrency' in value) || value['fromCurrency'] === undefined) return false;
    if (!('toCurrency' in value) || value['toCurrency'] === undefined) return false;
    if (!('rate' in value) || value['rate'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    return true;
}

export function FxRateFromJSON(json: any): FxRate {
    return FxRateFromJSONTyped(json, false);
}

export function FxRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxRate {
    if (json == null) {
        return json;
    }
    return {
        
        'fromCurrency': json['fromCurrency'],
        'toCurrency': json['toCurrency'],
        'rate': json['rate'],
        'validFrom': (new Date(json['validFrom'])),
    };
}

export function FxRateToJSON(json: any): FxRate {
    return FxRateToJSONTyped(json, false);
}

export function FxRateToJSONTyped(value?: FxRate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromCurrency': value['fromCurrency'],
        'toCurrency': value['toCurrency'],
        'rate': value['rate'],
        'validFrom': value['validFrom'].toISOString().substring(0,10),
    };
}

